import { render, staticRenderFns } from "./NewChatRoom.vue?vue&type=template&id=ab91fc56&scoped=true&"
import script from "./NewChatRoom.vue?vue&type=script&lang=js&"
export * from "./NewChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./NewChatRoom.vue?vue&type=style&index=0&id=ab91fc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab91fc56",
  null
  
)

export default component.exports